import { ContextFilter, SelfDescribingJson } from '@snowplow/browser-tracker'
import { FunnelContextDataProvider } from 'Snowplow'

/**
 * funnel_context is required on every event, so the filter always emits. All
 * fields resolve to safe defaults (user_type 'dtc', environment 'production')
 * even when localStorage is missing or malformed.
 */
function funnelContextFilter(): ContextFilter {
  return () => true
}

function funnelContextGenerator(dataProvider: FunnelContextDataProvider) {
  return (): SelfDescribingJson => {
    const data = dataProvider.readFunnelContextData()
    return {
      schema: 'iglu:com.healthcare/funnel_context/jsonschema/1-0-0',
      data: {
        funnel_type: data.funnel_type,
        funnel_version: data.funnel_version,
        user_type: data.user_type,
        environment: data.environment
      }
    }
  }
}

export { funnelContextGenerator, funnelContextFilter }
